import { useState, useEffect } from 'react';
import { ConditionLoading } from 'components/conditionLoading'
import { SatisfyItem } from './SatisfyItem'
import { DissatisfyItem } from './DissatisfyItem'
import { getPersonalService } from 'api/api'
import { WorkContext } from 'utils/getContext'

const LoggedIn = (props) => {
  const { type } = props
  const [recommendList, setRecommendList] = useState({})
  const cache = sessionStorage.getItem('recommendList')

  useEffect(() => {
    if (cache) {
      setRecommendList(JSON.parse(cache))
      return
    }
    getPersonalService(type).then(res => {
      setRecommendList(res)
      sessionStorage.setItem('recommendList', JSON.stringify(res))
    })
  }, [type, cache])

  // 如果没有数据，显示加载中
  if (Object.keys(recommendList).length === 0) {
    return (
      <ConditionLoading />
    )
  }

  return (
    <div className="logged-in">
      <WorkContext.Provider value={recommendList} >
        <SatisfyItem />
        <DissatisfyItem />
      </WorkContext.Provider>
    </div>
  );
};

export { LoggedIn };